<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          收银台
        </div>
        <div class="header-right">
          <el-button
            type="primary"
            icon="el-icon-tickets"
            size="small"
            v-if="!showPayResult"
            @click="
              linkTo(
                `/home/my/order?orderType=${
                  $route.query.orderType
                }&mallOrderId=${$route.query.mallOrderId}`
              )
            "
            >返回开单</el-button
          >
          <el-button type="danger" size="small" @click="linkTo('/')"
            >关闭</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="main">
          <div class="pay-result" v-if="showPayResult">
            <div class="pay-result-wrap">
              <img
                class="icon-success"
                src="@/assets/img/shop/icon-success.png"
                alt=""
              />
              <p class="price">￥{{ orderPrice }}</p>
              <p class="result-tips">收款成功</p>
              <el-button type="primary" @click="linkTo('/home/my/order')"
                >继续开单</el-button
              >
              <el-button @click="linkTo('/booking/list?type=add')"
                >预约下次</el-button
              >
              <el-button @click="printOrder">打印小票</el-button>
            </div>
          </div>
          <div class="pay-method" v-if="!showPayResult">
            <div class="title">选择收款方式</div>
            <div class="method-list">
              <div
                class="item"
                v-for="item in methodList"
                :key="item.value"
                :class="{
                  active: payMethod == item.value,
                }"
                @click="selPayMethod(item.value)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="pay-info" v-if="!showPayResult">
            <div class="order-info">
              <div class="order-pay-method">
                {{
                  methodList[
                    methodList.findIndex((val) => {
                      return val.value == payMethod;
                    })
                  ].name
                }}
              </div>
              <div class="order-price">
                ￥
                <span>{{ orderPrice }}</span>
              </div>
            </div>
            <div class="scan-pay" v-if="payMethod == 'scan'">
              <img
                class="img-scan"
                src="@/assets/img/order/img-scan.png"
                alt=""
                v-if="scanType == 'shop'"
              />
              <qrcode
                :value="payUrl"
                :options="{ size: 200 }"
                v-if="scanType == 'buyer'"
                class="scan-code-img"
              ></qrcode>
              <p class="tips" v-loading="isPaying">
                {{
                  scanType == "shop"
                    ? "使用扫码枪扫描客户的付款码"
                    : "客户手机扫此收款码"
                }}
              </p>
              <!-- <el-button
                type="primary"
                plain
                size="small"
                @click="toggleScanType"
                >{{
                  scanType == "shop" ? "切换到收款码" : "切换到扫码枪"
                }}</el-button
              > -->
            </div>
            <div class="cash-pay" v-if="payMethod == 'cash'">
              <div class="cash-input">
                <el-input
                  type="text"
                  placeholder="0.00"
                  v-model="cashValue"
                  @input="valueInput"
                  @blur="cashValueFormat"
                  @keyup.enter.native="cashValueFormat"
                ></el-input>
                <el-button type="text" @click="cashValue = orderPrice"
                  >不用找零</el-button
                >
              </div>
              <div
                class="cash-tips"
                v-show="cashValue && orderPrice - cashValue != 0"
              >
                {{ orderPrice - cashValue > 0 ? "还差" : "找零" }}
                <span class="price"
                  >￥{{ Math.abs(orderPrice - cashValue).toFixed(2) }}</span
                >
              </div>
              <el-button type="primary" szie="small" @click="cashPay"
                >确定付款</el-button
              >
            </div>
            <div class="vip-pay" v-if="payMethod == 'vip'">
              <div
                v-if="mapVipList[customerUserId]"
                class="card-item"
                :style="{
                  background: `linear-gradient(to bottom right, ${
                    mapVipList[customerUserId].startValue
                  }, ${mapVipList[customerUserId].endValue})`,
                }"
              >
                <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
                <span
                  class="card-name"
                  :style="{
                    color: `${mapVipList[customerUserId].textColor}`,
                  }"
                  >{{ mapVipList[customerUserId].cardName }}</span
                >
                <span class="tips">{{
                  mapVipList[customerUserId].cardSlogan
                }}</span>
                <span class="discount"
                  >{{
                    (mapVipList[customerUserId].discount * 100) / 10
                  }}折</span
                >
                <span class="wallet"
                  >余额：{{ mapVipList[customerUserId].wallet }}</span
                >
                <span class="score"
                  >积分：{{ mapVipList[customerUserId].score }}</span
                >
              </div>
              <el-button
                type="primary"
                szie="small"
                @click="payByShopMemberCard"
                >确定付款</el-button
              >
            </div>
          </div>
          <div class="print-info">
            <div class="temp-main">
              <div class="temp-wrap">
                <form id="form1">
                  <div class="title">{{ shopInfo.shopName }}</div>
                  <p class="split-line">
                    <span class="words">
                      订单信息
                    </span>
                    <span class="line" style="float:left"> </span>
                    <span class="line" style="float: right;"> </span>
                  </p>
                  <div class="two-columns">
                    <div class="item">
                      <span>订单编号：</span>
                      <span>{{ printInfo.tradeNo }}</span>
                    </div>
                    <div class="item">
                      <span>下单时间：</span>
                      <span>{{
                        printInfo.supplementDateTime || printInfo.createTime
                      }}</span>
                    </div>
                    <div class="item">
                      <span>打印时间：</span>
                      <span>{{ printInfo.printTime }}</span>
                    </div>
                    <div class="item">
                      <span>顾客备注：</span>
                      <span>{{ printInfo.buyerMark }}</span>
                    </div>
                    <div class="item">
                      <span>商家备注：</span>
                      <span>{{ printInfo.shopMark }}</span>
                    </div>
                  </div>
                  <p class="split-line">
                    <span class="words">
                      消费明细
                    </span>
                    <span class="line" style="float:left"> </span>
                    <span class="line" style="float: right;"> </span>
                  </p>
                  <div class="list-container" v-if="orderType != 'recharge'">
                    <div
                      class="goods"
                      v-for="(val, index) in printInfo.products"
                      :key="index"
                    >
                      <div class="goods-name font-bold mg-10">
                        {{ index + 1 }}.{{ val.goodsName }}
                      </div>
                      <p class="spec mg-10 ti-10">{{ val.specDesc }}</p>
                      <div class="two-columns" v-if="orderType == 'openOrder'">
                        <div class="item ti-10">
                          <span>数量</span>
                          <span>x{{ val.buyCount }}</span>
                        </div>
                        <div class="item ti-10">
                          <span>原价</span>
                          <span>{{
                            (
                              val.totalRetailPrice || val.totalTurnoverPrice
                            ).toFixed(2)
                          }}</span>
                        </div>
                        <div class="item ti-10">
                          <span>成交价</span>
                          <span>{{ val.totalTurnoverPrice.toFixed(2) }}</span>
                        </div>
                      </div>
                      <div class="two-columns" v-if="orderType == 'equityCard'">
                        <div class="item ti-10">
                          <span>数量</span>
                          <span>x{{ val.buyCount }}</span>
                        </div>
                        <div class="item ti-10">
                          <span>单价</span>
                          <span>{{
                            (
                              val.totalRetailPrice || val.totalTurnoverPrice
                            ).toFixed(2)
                          }}</span>
                        </div>
                      </div>
                      <div class="two-columns" v-if="orderType == 'recharge'">
                        <div class="item ti-10">
                          <span>充值金额</span>
                          <span>x{{ val.buyCount }}</span>
                        </div>
                        <div class="item ti-10">
                          <span>赠送金额</span>
                          <span>{{
                            (
                              val.totalRetailPrice || val.totalTurnoverPrice
                            ).toFixed(2)
                          }}</span>
                        </div>
                        <div class="item ti-10">
                          <span>到账金额</span>
                          <span>{{ val.totalTurnoverPrice.toFixed(2) }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="two-columns font-bold"
                      v-if="orderType == 'openOrder'"
                    >
                      <div class="item">
                        <span>小计</span>
                        <span>{{ printInfo.payMoney }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="list-container" v-if="orderType == 'recharge'">
                    <div class="goods">
                      <div class="goods-name font-bold mg-10">
                        1.会员充值
                      </div>
                      <div class="two-columns">
                        <div
                          class="item ti-10"
                          v-for="(val, index) in printInfo.products"
                          :key="index"
                        >
                          <span>{{ val.goodsName }}</span>
                          <span>{{ val.totalTurnoverPrice.toFixed(2) }}</span>
                        </div>
                        <div class="item ti-10">
                          <span>到账金额</span>
                          <span>{{
                            (
                              printInfo.products[0].totalTurnoverPrice * 1 +
                              printInfo.products[1].totalTurnoverPrice * 1
                            ).toFixed(2)
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="two-columns font-bold"
                      v-if="orderType == 'openOrder'"
                    >
                      <div class="item">
                        <span>小计</span>
                        <span>{{ printInfo.payMoney }}</span>
                      </div>
                    </div>
                  </div>
                  <p class="split-line" v-if="printInfo.memberWallet">
                    <span class="words">
                      会员信息
                    </span>
                    <span class="line" style="float:left"> </span>
                    <span class="line" style="float: right;"> </span>
                  </p>
                  <div class="two-columns" v-if="printInfo.memberWallet">
                    <div class="item">
                      <span>会员号：</span>
                      <span>{{ printInfo.memberName }}</span>
                    </div>
                    <div class="item" v-if="printInfo.buyerPhone">
                      <span>手机号：</span>
                      <span
                        >{{ String(printInfo.buyerPhone).slice(0, 3) }}****{{
                          String(printInfo.buyerPhone).slice(
                            String(printInfo.buyerPhone).length - 4,
                            String(printInfo.buyerPhone).length
                          )
                        }}</span
                      >
                    </div>
                    <div class="item">
                      <span>会员余额：</span>
                      <span>{{ printInfo.memberWallet }}</span>
                    </div>
                    <div class="item">
                      <span>会员积分：</span>
                      <span>{{ printInfo.memberScore }}</span>
                    </div>
                  </div>
                  <div class="order-info">
                    <div class="two-columns">
                      <div class="item font-bold mg-10">
                        <span>商品合计</span>
                        <span>{{ printInfo.totalRetailPrice }}</span>
                      </div>
                      <div class="item font-bold mg-10">
                        <span>优惠合计</span>
                        <span>{{ printInfo.shopPromotionTotalPrice }}</span>
                      </div>
                      <div class="two-columns">
                        <div
                          class="item mg-10"
                          v-for="item in printInfo.shopPromotionDataList"
                          :key="item.name"
                        >
                          <span>{{ item.name }}</span>
                          <span
                            >{{ item.price > 0 ? "-" : ""
                            }}{{ item.price }}</span
                          >
                        </div>
                      </div>
                      <div class="item mg-10">
                        <span>支付方式</span>
                        <span>{{
                          payInterfacePartyTypes[
                            printInfo.payInterfacePartyType
                          ]
                        }}</span>
                      </div>
                      <div class="item font-bold mg-10">
                        <span>实际支付</span>
                        <span>{{ printInfo.payMoney }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="shop-info">
                    <p class="mg-10">地址：{{ shopInfo.shopAddress }}</p>
                    <p class="mg-10">联系电话：{{ shopInfo.linkTel }}</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShopInfo,
  orderInfo,
  getShopMemberList,
  handleOrderForShopWorker,
  payByShopMemberCard,
  userPayScan,
  payResult,
  shopMemberRecharge,
} from "@/api/index.js";
import qrcode from "@xkeshi/vue-qrcode";
import { mapState, mapActions } from "vuex";
import { getLodop } from "@/utils/LodopFuncs.js";
import { commonFuc } from "@/mixins/commonFuc";
let pollingTimeStamp = +new Date();
export default {
  mixins: [commonFuc],
  data() {
    return {
      isPaying: false,
      payMethod: "scan",
      shopMemberId: "",
      orderPrice: 0,
      mallOrderId: "",
      orderType: "",

      scanType: "shop",
      payUrl: "",
      cashValue: "",
      mapVipList: {},
      customerUserId: "",

      printInfo: {
        tradeNo: "ABC456789987",
        createTime: "2022-04-29 10:23:33",
        printTime: "2022-04-29 10:23:33",
        buyerMark: "加辣",
        shopMark: "加辣",
        products: [],
      },
      authCode: "",

      showPayResult: false,
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    methodList() {
      let list = [
        {
          name: "扫码支付",
          value: "scan",
        },
        {
          name: "现金支付",
          value: "cash",
        },
      ];
      if (this.shopMemberId && this.orderType != "recharge") {
        list.push({
          name: "会员支付",
          value: "vip",
        });
      }
      return list;
    },
  },
  mounted() {
    this.orderType = this.$route.query.orderType;
    if (this.$route.query.mallOrderId) {
      this.mallOrderId = this.$route.query.mallOrderId;
      this.orderInfo(this.$route.query.mallOrderId);
    }
    getShopInfo().then((shopInfo) => {
      this.updateShopInfo(shopInfo.data);
    });
    document.onkeydown = (e) => {
      console.log(e, "onkeydown");
      // var b;
      if (e.key == "Enter") {
        this.userPayScan();
        this.authCode = "";
      }
      if (e.key != "Enter") {
        this.authCode += e.key;
      }
    };
  },
  methods: {
    ...mapActions(["updateShopInfo"]),
    orderInfo(mallOrderId) {
      orderInfo({ mallOrderId }).then((res) => {
        if (res.code == 1) {
          let json = res.data;
          this.shopMemberId = json.shopMemberId;
          this.orderPrice = json.payMoney;
          this.cashValue = json.payMoney;
          this.customerUserId = json.buyerUserId;
          this.printInfo = {
            tradeNo: json.tradeNo,
            supplementDateTime: json.supplementDateTime || json.createTime,
            createTime: json.createTime,
            printTime: new Date().pattern("yyyy-MM-dd HH:mm:ss"),
            buyerMark: json.buyerMark,
            shopMark: json.orderMark,
            products: json.products,
            payMoney: json.payMoney,
            memberName: json.memberName,
            buyerPhone: json.buyerPhone,
            memberWallet: json.memberWallet,
            memberScore: json.memberScore,
            totalRetailPrice: json.totalRetailPrice,
            shopPromotionTotalPrice: json.shopPromotionTotalPrice,
            shopPromotionDataList: json.shopPromotionDataList
              ? json.shopPromotionDataList
              : [],
            payInterfacePartyType: json.payInterfacePartyType,
            payMoney: json.payMoney,
            saleUserId: json.saleUserId,
          };
          if (this.shopMemberId) {
            this.getShopMember();
          }
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    selPayMethod(value) {
      this.payMethod = value;
    },
    toggleScanType() {
      this.scanType = this.scanType == "shop" ? "buyer" : "shop";
    },
    valueInput(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = e.target.value.replace(/\.{2,}/g, ".");
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
      e.target.value = e.target.value.replace(/^\./g, "0.");
      e.target.value = e.target.value.replace(
        /^\d*\.\d*\./g,
        e.target.value.substring(0, e.target.value.length - 1)
      );
      if (!e.target.value && e.target.value != 0) {
        e.target.value = "";
      }
      if (e.target.value <= 0) {
        e.target.value = 0;
      }
    },
    cashValueFormat(e) {
      e.target.value = Number(e.target.value).toFixed(2);
    },
    getShopMember() {
      getShopMemberList({
        pageNo: 1,
        row: 9999,
        phoneNum: String(this.printInfo.buyerPhone),
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            this.mapVipList[val.customerUserId] = val;
          });
        }
      });
    },
    printOrder() {
      let style = `*{box-sizing:border-box}.temp-wrap{margin-left: -30px;}
          * {
            box-sizing: border-box;
            font-size: 12px;
          }
          .title {
            text-align: center;
            font-size: 20px;
          }
          .split-line {
            line-height: 25px;
          }
          .split-line .line {
            width: 25%;
            border-bottom: 1px dotted black;
            margin-top: -12.5px;
            display: inline-block;
            *display: block;
            *display: inline;
          }
          .split-line .words {
            width: 100%;
            display: inline-block;
            *display: block;
            *display: inline;
            text-align: center;
            font-size: 14px;
          }
          .two-columns .item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            *display: block;
            *display: inline;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;
          }
          .two-columns .item span:first-child {
            min-width: 60px;
          }
          .two-columns .item span:last-child {
            word-break: break-all;
          }
          .ti-10 {
            text-indent: 10px;
          }
          .mg-10 {
            margin-bottom: 10px;
          }
          .font-bold {
            font-weight: bold;
          }
          #form1 {
            padding: 20px;
            width: 100%;
          }
          .goods {
            width: 100%;
          }
          .order-info {
            padding-top: 10px;
            border-top: 1px dotted black;
            border-bottom: 1px dotted black;
          }
          .shop-info {
            text-align: center;
            padding: 10px 0;
          }`;
      let basePath = "https://www.madiancan.com/";
      let templateHtml = `<!DOCTYPE html><html><head><meta charset='utf-8'/><style>html,body{height:100%;width:100%;margin:0;padding:0}${style}</style></head><body>${
        document.querySelector(".temp-main").innerHTML
      }</body></html>`;
      LODOP = getLodop();
      console.log(templateHtml);
      if (!LODOP) {
        if (confirm("打印机连接失败,查看解决方案？")) {
          window.location.href = basePath + "print/tip.html";
        } else {
          return;
        }
      }
      LODOP.PRINT_INIT("订单小票");
      LODOP.ADD_PRINT_HTM(0, 10, "100%", "100%", templateHtml);
      LODOP.SET_PRINT_COPIES(1); //设置打印份数
      LODOP.SET_PRINT_PAGESIZE(
        3,
        (localStorage.getItem("printWidth") || 58) * 10,
        40,
        ""
      );
      // LODOP.PREVIEW();
      LODOP.SET_PRINTER_INDEXA(LODOP.GET_PRINTER_NAME("-1"));
      LODOP.PRINT();
    },
    paySuccess() {
      this.$notify({
        title: "提示",
        message: "支付成功",
        type: "success",
        duration: 2000,
      });
      this.showPayResult = true;
    },
    cashPay() {
      if (this.orderType == "recharge") {
        shopMemberRecharge({
          shopMemberId: this.shopMemberId,
          payMoney: this.printInfo.payMoney,
          receiptType: 1,
          saleUserId: this.printInfo.saleUserId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "付款成功",
              type: "success",
            });
            this.orderInfo(res.data.mallOrderId);
            this.paySuccess();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        if (this.payMethod == "cash") {
          if (this.cashValue < this.orderPrice) {
            return this.$message.error("收款金额不能小于订单金额");
          }
        }
        this.handleOrderForShopWorker();
      }
    },
    handleOrderForShopWorker() {
      handleOrderForShopWorker({
        mallOrderId: this.mallOrderId,
        orderStatus: 40,
      }).then((res) => {
        if (res.code == 1) {
          this.orderInfo(this.mallOrderId);
          this.paySuccess();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    payByShopMemberCard() {
      payByShopMemberCard({
        mallOrderId: this.mallOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.orderInfo(this.mallOrderId);
          this.paySuccess();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    userPayScan() {
      userPayScan({
        mallOrderId: this.mallOrderId,
        shopMemberCode: this.authCode,
      }).then((res) => {
        if (res.code == 1) {
          this.isPaying = true;
          pollingTimeStamp = +new Date();
          this.payResult(this.mallOrderId);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    payResult(mallOrderId) {
      payResult({
        mallOrderId,
      }).then((res) => {
        if (res.code == 1) {
          if (res.data.orderStatus == 40) {
            this.isPaying = false;
            this.orderInfo(mallOrderId);
            this.paySuccess();
            return;
          }
        } else {
          this.isPaying = false;
          return this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        if ((+new Date() - pollingTimeStamp) / 1000 >= 30) {
          this.isPaying = false;
          return this.$notify({
            title: "提示",
            message: "支付失败，请重试",
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.payResult(mallOrderId);
        }, 1e3);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  height: 100%;
  overflow: hidden;
  .bd {
    height: 100%;
    .tab-header {
      .header-left {
        line-height: 32px;
      }
    }
  }
  .tab-content {
    height: calc(100% - 63px);
    width: 100%;
    .main {
      width: 100%;
      display: flex;
      padding-top: 0;
      height: 100%;
      .pay-result {
        flex: 3;
        padding-top: 200px;
        border-right: 1px solid #eeeeee;
        .pay-result-wrap {
          display: flex;
          flex-direction: column;
          width: 300px;
          margin: 0 auto;
          text-align: center;
          align-items: center;
          justify-content: center;
          .price {
            font-size: 24px;
            padding-top: 25px;
          }
          .result-tips {
            color: #999;
            font-size: 14px;
            margin-top: 10px;
            margin-bottom: 25px;
          }
          .icon-success {
            width: 100px;
            height: 100px;
          }
          .el-button {
            margin: 10px 0 0 0;
            width: 300px;
          }
        }
      }
      .pay-method {
        padding: 20px;
        flex: 1;
        .title {
          font-size: 20px;
          margin: 20px 0;
          color: #000;
        }
        .method-list {
          height: 300px;
          overflow: auto;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: flex-start;
          align-items: flex-start;
          margin: 30px 0;
          .item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100px;
            margin: 0 10px 10px 0;
            border: 1px solid #ebedf0;
            border-radius: 4px;
            height: 50px;
            padding: 10px;
            box-sizing: border-box;
            justify-content: center;
            cursor: pointer;
            &:hover {
              background: #ecf5ff;
            }
            &.active {
              background: #ecf5ff;
              border-color: #b3d8ff;
              color: #409eff;
            }
          }
        }
      }
      .pay-info {
        flex: 2;
        border: 1px solid #eeeeee;
        border-top: 0;
        border-bottom: 0;
        padding: 20px;
        text-align: center;
        .order-info {
          .order-pay-method {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .order-price {
            font-size: 24px;
            font-weight: bold;
            color: #ff2278;
            & > span {
              font-size: 36px;
            }
          }
          & ~ div {
            margin-top: 100px;
          }
        }
        .scan-pay {
          .img-scan,
          .scan-code-img {
            width: 200px;
            height: 200px;
          }
          .tips {
            height: 28px;
            font-size: 16px;
            line-height: 28px;
            margin: 16px 0 32px;
            color: #969799;
          }
        }
        .cash-pay {
          position: relative;
          width: 300px;
          height: 300px;
          margin: 0 auto;
          .cash-input {
            display: flex;
            align-items: center;
            .el-input {
              margin-right: 10px;
            }
          }
          .cash-tips {
            height: 30px;
            line-height: 30px;
            text-align: left;
            font-size: 14px;
            padding-left: 10px;
          }
          & > .el-button {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
          }
        }
        .vip-pay {
          text-align: center;
          .card-item {
            width: 297px;
            height: 172px;
            border-radius: 20px;
            position: relative;
            margin: 10px auto 60px;
            & > span {
              position: absolute;
            }
            button + & {
              margin-top: 20px;
            }
            .card-bg {
              top: 50%;
              position: absolute;
              left: -25%;
              transform: translateY(-50%);
            }
            .card-name {
              font-size: 22px;
              font-weight: bold;
              left: 20px;
              top: 10px;
            }
            .price {
              font-size: 22px;
              color: #fff;
              left: 20px;
              top: 54px;
            }
            .discount {
              font-size: 22px;
              color: #fafafa;
              top: 54px;
              right: 20px;
            }
            .endtime {
              font-size: 20px;
              color: #fafafa;
              left: 20px;
              bottom: 20px;
            }
            .sale {
              font-size: 20px;
              color: #fafafa;
              right: 20px;
              bottom: 20px;
            }
            .tips {
              font-size: 14px;
              color: #fafafa;
              left: 20px;
              top: 54px;
            }
            .discount {
              font-size: 30px;
              color: #fafafa;
              top: 54px;
              right: 20px;
            }
            .wallet {
              font-size: 16px;
              color: #fafafa;
              left: 20px;
              bottom: 20px;
            }
            .score {
              font-size: 16px;
              color: #fafafa;
              left: 60%;
              transform: translateX(-50%);
              bottom: 20px;
            }
          }
        }
      }
      .print-info {
        flex: 1;
        .temp-main {
          overflow: auto;
          height: 100%;
          margin: 0 auto;
          width: 100%;
          * {
            box-sizing: border-box;
            font-size: 12px;
          }
          .title {
            text-align: center;
            font-size: 20px;
          }
          .split-line {
            line-height: 25px;
          }
          .split-line .line {
            width: 25%;
            border-bottom: 1px dotted black;
            margin-top: -12.5px;
            display: inline-block;
            *display: block;
            *display: inline;
          }
          .split-line .words {
            width: 100%;
            display: inline-block;
            *display: block;
            *display: inline;
            text-align: center;
            font-size: 14px;
          }
          .two-columns .item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            *display: block;
            *display: inline;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;
          }
          .two-columns .item span:first-child {
            min-width: 60px;
          }
          .two-columns .item span:last-child {
            word-break: break-all;
          }
          .ti-10 {
            text-indent: 10px;
          }
          .mg-10 {
            margin-bottom: 10px;
          }
          .font-bold {
            font-weight: bold;
          }
          #form1 {
            padding: 20px;
            width: 100%;
          }
          .goods {
            width: 100%;
          }
          .order-info {
            padding-top: 10px;
            border-top: 1px dotted black;
            border-bottom: 1px dotted black;
          }
          .shop-info {
            text-align: center;
            padding: 10px 0;
          }
        }
      }
    }
  }
  .price {
    color: #ff2278;
  }
}
</style>
